import { makeStyles } from '@mui/styles'
import colors from '../../../utils/colors'
const useStyles = makeStyles((theme) => ({
  indicatorContainer: { marginBottom: '16px' },
  textBreadcrum: { color: colors.breadcrumColor, textDecoration: 'none' },
  textEmail: {},
  headerContainer: {
    border: colors.disabledLighten + ' solid 1px',
    borderRadius: '4px',
    padding: '8px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      margin: '0 auto',
    },
  },
  "&.MuiTypography-root": {
    marginLeft: '14px',
  },
  titleContainer: {
    width: '30%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '50%',
    },
  },
  headerTitle: {
    padding: 0,
  },
  informationContainer: {
    width: '69%',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '50%',
      flexWrap: 'wrap',
      flexDirection: 'column',
      alignItems: 'flex-start',
      paddingLeft: '16px',
    },
  },
  textHeaderContainer: {
    display: 'flex',
  },
  iconHeaderText: {
    marginRight: '8px',
  },
  editContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  iconLock: {
    marginRight: '16px',
  },
  bodyContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    padding: '16px 0',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
  },
  bodyContainerBtns: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'nowrap',
    marginTop: '0px',
    '& .endButton': {
      marginRight: '20px',
    },
  },
  bodyContainerBtnsEnd: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'nowrap',
    marginTop: '0px',
    '& .endButton': {
      marginRight: '20px',
    },
  },
  editUserBody: {
    padding: '0 14px',
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  textContainer: {
    color: colors.disabledDarken,
    [theme.breakpoints.down('md')]: {
      paddingLeft: '10px',
    },
  },
  textContainerTitle: {
    marginBottom: '16px',
  },
  editUserContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRadius: '3px',
    padding: '16px 10px 16px 10px',
    border: colors.disabledLighten + ' solid 1px',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '334px',
      marginTop: '24px',
    },
  },
  editUserHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '15px',
    justifyContent: 'flex-start',
    marginBottom: '24px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '16px',
      marginBottom: '16px',
    },
  },
  buttonCancel: {
    textTransform: 'none',
  },
  finishContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    height: '150px',
    alignItems: 'center',
    width: '40%',
    margin: '0 auto',
    padding: '32px 0',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  chekCircle: {
    color: colors.lightPrimary,
    '&.MuiSvgIcon-root': {
      fontSize: '50px',
    },
  },
  submit: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  loading: {
    position: 'absolute',
    top: '40%',
    left: '50%',
  },
  snackbar: {
    position: 'fixed',
    top: '13vh',
    left: '50vw',
  },
}))

export default useStyles
